The URI to navigate to when the button is clicked.
